
// -------------- PRODUCT Page --------------
export const TRANSACTION_FIELD_ERROR       = 'TRANSACTION_FIELD_ERROR';
export const TRANSACTION_FIELD_RESET_ERROR = 'TRANSACTION_FIELD_RESET_ERROR';
export const TRANSACTION_GET_ITEM          = 'TRANSACTION_GET_ITEM';
export const TRANSACTION_SET_ITEM          = 'TRANSACTION_SET_ITEM';
export const TRANSACTION_SET_ALL           = 'TRANSACTION_SET_ALL';
export const TRANSACTION_ADD_ITEM          = 'TRANSACTION_ADD_ITEM';
export const TRANSACTION_USER_ID           = 'TRANSACTION_USER_ID';



// --------- TRANSACTION Page ---------
export function transactionFieldError(field, fieldData = {}) {
    return { type: TRANSACTION_FIELD_ERROR, fieldName: field, fieldData: fieldData }
}

export function transactionFieldResetError(field, fieldData = {}) {
    return { type: TRANSACTION_FIELD_RESET_ERROR }
}
export function transactionGetItem(targetItem) {
    return { type: TRANSACTION_GET_ITEM, data: targetItem }
}
export function transactionSetItem(targetItem) {
    return { type: TRANSACTION_SET_ITEM, data: targetItem }
}
export function transactionAddItem(addItem) {
    return { type: TRANSACTION_ADD_ITEM, data: addItem }
}
export function transactionSetList(allTRANSACTION) {
    return { type: TRANSACTION_SET_ALL, data: allTRANSACTION }
}
